import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IOrders } from "../../interfaces/IOrder";
import { IReduxAppState } from "../../reducers";
import APIDefintions from '../../yoello-lib/modules/API/APIDefs';
import { OrderList } from "./OrderList/OrderList";
import useFormatCurrency from "../../yoello-lib/modules/localisation/useCurrency";
import detailsStyles from "../../scss/orderDetails.module.scss"
import { DialogOrderTypes, IProcessedOrders } from "./constants";
import { columns as orderHistoryColumn } from './Columns/OrderHistory.columns'
import useAPI from "../../yoello-lib/modules/API/useAPI";
// import { useAuth0 } from "../../yoello-lib/modules/auth/Auth0";
import { useSideTabs } from "../../hooks/useSideTabs";
import { MenuContainerTabs } from "../Routes";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { OrderDetailsDialog } from "./Dialogs/OrderDetailsDialog";
import { IOrderRouteChildren } from "./OrderRouter";
import { BY_ID, dialogKeys, ISSUE_REFUND_URL , SPECIFIC_ITEMS_REFUND_URL , REFUND_REASONS_URL } from "../../const/URL.const";
import { MultiDialogRoute } from "../dialogRoutes/MultiDialogRoute";
import { IssueRefundDialog } from "./PartialRefund/IssueRefundDialog";
import { OrderDetailsChecklistDialog } from "./PartialRefund/OrderDetailsChecklistDialog";
import { useAuthenticationContext } from "../../yoello-lib/modules/auth/AuthenticationContext";
export function OrdersContainer({ tab, collectionPoints }: IOrderRouteChildren) {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const [orderList, setOrdersList] = useState<IProcessedOrders[]>([]);
    useSideTabs(tab);
    const { retrieveAccessToken } = useAuthenticationContext();
    const { isLoading, callAPI: ordersAPICall, apiData } = useAPI<IOrders>(APIDefintions.orders, retrieveAccessToken, { preQuery: selectedVenueId });
    let { path } = useRouteMatch();
    useEffect(() => {
        if (apiData) {
            if (Array.isArray(apiData)) {
                formatOrderList(apiData);
            } else {
                ordersAPICall(HTTPMethods.GET);
            }
        }
        // eslint-disable-next-line
    }, [apiData]);
    const { formatCurrency } = useFormatCurrency();

    function formatOrderList(orderList: IOrders[]) {
        const processedData = orderList.map((order) => {
            const date = new Date(Date.parse(order.created_on));
            return {
                ...order,
                order_total: formatCurrency(order.order_total, true, order.currency_iso_code),
                created_on_time: date.toLocaleTimeString(),
                created_on_date: date.toLocaleDateString(),
            }
        })
        setOrdersList(processedData);
    }

    return <Switch>
        <Route path={path}>
            <OrderList mainKey={MenuContainerTabs.ORDER_HISTORY.key} columns={orderHistoryColumn} isLoading={isLoading} orderList={orderList || []}
                orderAPICall={ordersAPICall} venueId={selectedVenueId} path={path}
            />
            <MultiDialogRoute
                RouteSteps={[
                    {
                        key: dialogKeys.ORDER,
                        Component: OrderDetailsDialog,
                        path: `${path}${BY_ID}`,
                        title: "orderHistory.modal.title",
                        componentProps: {
                            collectionPoints,
                            dialogType: DialogOrderTypes.ORDER_HISTORY,
                            orderAPI: ordersAPICall,
                        },
                        dialogClassName:detailsStyles.OrderHistoryPageDialog,
                        isFormDialog:false,
                        exact:true
                    },
                    {
                        key: dialogKeys.PARTIALREFUND,
                        Component: IssueRefundDialog,
                        path: `${path}${BY_ID}${ISSUE_REFUND_URL}`,
                        title: "PartialReafund.OrderHistory.Void.DialogTitle",
                        exact:true
                    },
                    {
                        key: dialogKeys.SPECIFICITEMSREFUND,
                        Component: OrderDetailsChecklistDialog,
                        path: `${path}${BY_ID}${SPECIFIC_ITEMS_REFUND_URL}`,
                        title: "PartialReafund.OrderHistory.SpecificItemsDialogTitle",
                        dialogClassName:detailsStyles.ModalContainer,
                        exact:true
                    },
                    {
                        key: dialogKeys.PARTIALREFUNDREASONS,
                        Component: IssueRefundDialog,
                        path: `${path}${BY_ID}${REFUND_REASONS_URL}`,
                        title: "PartialReafund.OrderHistory.Void.DialogTitle",
                        exact:true
                    },
                ]}
                navigateBackRotue={path}
            />
        </Route>
    </Switch>
}